<template>
  <div
    class="relative isolate z-auto flex gap-1 rounded px-0.5 hover:z-50 hover:bg-lexmea-gray-600"
  >
    <LinkText
      v-for="link in linkChain.links"
      :key="link.id"
      :link="link"
      :linkChain="linkChain"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ILinkChain } from "~/models/IUserEntry";

defineProps<{
  linkChain: ILinkChain;
}>();
</script>
